import { useContext } from 'react'
import { MapDataContext } from 'src/store/map/Store'

import { StatsDataContext } from 'src/store/stats/Store'

const useLightRadius = () => {
  const { stats } = useContext(StatsDataContext)
  const { map } = useContext(MapDataContext)
  const { location_id } = map.variables
  const { tile_size } = map.counters
  const { light_radius } = stats.total

  const darkLocations = ['wilderness', 'desert']
  const lights_on = darkLocations.includes(location_id)
  const lightRadius = light_radius * tile_size * 2
  
  return { lightRadius, lights_on }
}

export default useLightRadius
